export const ANALYTICS_MEASUREMENT_ID = "G-Z60V51K9ES";
export type AnalyticsPreference = "pending" | "granted" | "denied";

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
  interface Navigator {
    globalPrivacyControl?: boolean;
  }
}

const storageKey = "art-temkin-analytics";
let configured = false;

export function readAnalyticsPreference(): AnalyticsPreference {
  const saved = window.localStorage.getItem(storageKey);
  if (saved === "granted" || saved === "denied") return saved;
  if (navigator.globalPrivacyControl || navigator.doNotTrack === "1") return "denied";
  return "pending";
}

export function saveAnalyticsPreference(preference: Exclude<AnalyticsPreference, "pending">) {
  window.localStorage.setItem(storageKey, preference);
}

function configureDataLayer() {
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag(...args: unknown[]) { window.dataLayer!.push(args); };
}

export function enableAnalytics() {
  if (configured) return;
  configured = true;
  configureDataLayer();
  window.gtag!("consent", "default", {
    analytics_storage: "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });
  window.gtag!("consent", "update", { analytics_storage: "granted" });
  window.gtag!("js", new Date());
  window.gtag!("config", ANALYTICS_MEASUREMENT_ID, {
    page_title: "Art by Vadim Temkin",
    page_location: `${window.location.origin}${window.location.pathname}`,
    allow_google_signals: false,
    allow_ad_personalization_signals: false,
  });
  if (!document.getElementById("art-temkin-google-tag")) {
    const script = document.createElement("script");
    script.id = "art-temkin-google-tag";
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${ANALYTICS_MEASUREMENT_ID}`;
    document.head.appendChild(script);
  }
}

export function disableAnalytics() {
  if (window.gtag) window.gtag("consent", "update", { analytics_storage: "denied" });
  for (const cookie of document.cookie.split(";")) {
    const name = cookie.split("=")[0]?.trim();
    if (name?.startsWith("_ga")) document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Lax`;
  }
}
